import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=49f627a2"
import script from "./Ecommerce.vue?vue&type=script&lang=js"
export * from "./Ecommerce.vue?vue&type=script&lang=js"
import style0 from "./Ecommerce.vue?vue&type=style&index=0&id=49f627a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports